var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrepTasks',{attrs:{"team":"chopping","team-filter":_vm.teamFilter,"show-late-warnings":"","late-warning-priority-deadlines":_vm.lateWarningPriorityDeadlines,"can-set-estimate":!_vm.$route.meta.readOnly,"one-task-at-a-time":""}})}
var staticRenderFns = []

export { render, staticRenderFns }